import React from "react";
import { Card, Divider, Icon, Image, Stack, Text } from "@bookingcom/bui-react";
import { CheckmarkSelectedFillIcon } from "@bookingcom/bui-assets-react/streamline";
import { FlightDetailsSectionTitleDesktopUI } from "./FlightDetailsSectionTitle.desktop.ui.js";
export function FlightDetailsGeniusBenefitsDesktopUI(props) {
    const { attributes, mixin, header, benefits, footer, headerWithIcon, geniusImgAlt } = props;
    if (!benefits || benefits.length === 0)
        return null;
    return (React.createElement(Stack, { gap: 2, attributes: attributes, mixin: mixin },
        header ? (React.createElement(FlightDetailsSectionTitleDesktopUI, { title: header, asset: headerWithIcon ? { setName: "illustrations-traveller", assetName: "FlightsGeniusBenefits" } : undefined })) : undefined,
        React.createElement(Card, null,
            React.createElement(Stack, { gap: 3 },
                React.createElement(Stack, { gap: 2 }, benefits.map((benefit) => (React.createElement(Stack, { key: benefit.key, direction: "row", gap: 2 },
                    React.createElement(Stack.Item, { mixin: { paddingBlockStart: 0.6 } },
                        React.createElement(Icon, { size: "smaller", color: "brand_genius_secondary", svg: CheckmarkSelectedFillIcon })),
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(Text, { variant: "body_2" }, benefit)))))),
                footer ? (React.createElement(React.Fragment, null,
                    React.createElement(Divider, null),
                    React.createElement(Stack, { direction: "row" },
                        React.createElement(Stack.Item, { grow: true },
                            React.createElement(Text, { variant: "small_1", color: "neutral_alt" }, footer)),
                        React.createElement(Image, { alt: geniusImgAlt || "", height: 3, contentMode: "fit", mixin: { marginBlockStart: 0.75 }, asset: { setName: "images-genius", assetName: "GeniusLogoTraveller" } })))) : undefined))));
}
